export default __webpack_public_path__ + "static/media/greetings-login.31b46621.svg";